import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { I18nModule, ConfigModule, CmsConfig, UrlModule } from '@spartacus/core';
import { KnBrOrderDetailsActionsComponent } from './kn-br-order-details-actions.component';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        NgbTooltipModule,
        RouterModule,
        UrlModule,
        ConfigModule.withConfig({
            cmsComponents: {
                AccountOrderDetailsActionsComponent: {
                    component: () => import('./kn-br-order-details-actions.component').then((c) => c.KnBrOrderDetailsActionsComponent),
                },
            },
        } as CmsConfig),
        KnBrOrderDetailsActionsComponent,
    ],
})
export class KnBrOrderDetailsActionsModule {}
